// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2HpUd","badges":"styles_badges__3PXyn"};